import { LocationStrategy } from '@angular/common';
import { Injectable } from '@angular/core';
import { BLANK } from '../../constant/special-characters-constant';

@Injectable({
  providedIn: 'root'
})
export class DisableBrowserBFService {

  constructor(private location: LocationStrategy) {}

  public disableBrowserBackFn(): void {
    history.pushState(null, BLANK, window.location.href);
    this.location.onPopState(() => {
      history.pushState(null, BLANK, window.location.href);
    });
  }

}
